import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import CancleDone from "../../assets/cancle.png";

const CancelSuccessModal = ({ open, setCancleSuccessflag, message}) => {
   const machineId=localStorage.getItem("machineId")
   console.log("machineId",machineId)
  return (
    <Modal
      open={true}
      onClose={() => setCancleSuccessflag(false)}
      aria-labelledby="cancel-success-modal"
      aria-describedby="cancel-success-description"
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Box
        sx={{
          position: "relative",
          width: 300,
          bgcolor: "background.paper",
          borderRadius: 3,
         
          p: 3,
          pt: 6, // extra top padding for image
          textAlign: "center",
        }}
      >
        {/* Top Image */}
        <Box
          component="img"
          src={CancleDone}
          alt="Cancel Done"
          sx={{
            position: "absolute",
            top: -75, // half outside
            left: "50%",
            transform: "translateX(-50%)",
            width: 140,
            height: 140,
          }}
        />

        {/* Message */}
        <Typography
          id="cancel-success-modal"
          variant="h6"
          sx={{
            color: "#384F6F",
            fontWeight: 700,
            mt: 2,
          }}
        >
          {message}
        </Typography>

        <Typography
          id="cancel-success-description"
          variant="body2"
          sx={{
            color: "rgba(56,79,111,0.69)",
            mt: 1,
          }}
        >
          Your order has been cancelled
        </Typography>

        {/* OK Button */}
        <Link
          to={`/items?machineId=${machineId}&showItems=true`}
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="contained"
            color="success"
            sx={{
              mt: 3,
              width: "100%",
              textTransform: "none",
            }}
            onClick={() => setCancleSuccessflag(false)}
          >
            OK
          </Button>
        </Link>
      </Box>
    </Modal>
  );
};

export default CancelSuccessModal;
